/*
* 仓库管理
* */
export const WAREHOUSEGETPAGE = 'WAREHOUSEGETPAGE'
export const WAREHOUSEADD = 'WAREHOUSEADD'
export const WAREHOUSEUPDATA = 'WAREHOUSEUPDATA'
export const WAREHOUSERESET = 'WAREHOUSERESET'
export const GETCITY = 'GETCITY'
export const GETCHANNELTYPE = 'GETCHANNELTYPE'
export const GETWAREHOUSEPAY = 'GETWAREHOUSEPAY'
export const WAREHOUSEPAYUPDATA = 'WAREHOUSEPAYUPDATA'
/**
 * 仓库列表
 */
export const xxx = 'xxx'



// WEBPACK FOOTER //
// ./src/store/wareManage/types.js